/**
 * A Mongo reference as the API may return it: a bare id string, or the
 * referenced document populated (`{ _id, id?, name, ... }`) — e.g. `Pod.leadId`
 * comes back populated from `GET /api/pods` and `GET /api/pods/:id`.
 */
export type RefLike = string | { id?: string; _id?: string } | null | undefined;

/**
 * Id of a possibly-populated reference. Comparing `user.id === pod.leadId`
 * against a populated ref is always false (it was why pod leads never saw the
 * Edit/Members controls on their own pod).
 */
export const getRefId = (ref: unknown): string | undefined => {
  if (!ref) return undefined;
  if (typeof ref === 'string') return ref;
  if (typeof ref === 'object') {
    const { id, _id } = ref as { id?: unknown; _id?: unknown };
    const value = id ?? _id;
    return value ? String(value) : undefined;
  }
  return undefined;
};
